const locale = {
  TITLE: 'Home Page',
  TABLE_LOG_DATE: 'Date',
  TABLE_LOG_DETAIL: 'Details',
  TABLE_LOG_ACTIONED_USER: 'User',
  BUTTON_SHOW_MORE: 'Show More',
  BUTTON_DASHBOARD: 'Dashboard',
  TABLE_NOTIFICATION_CONTENT: 'Details',
  TABLE_NOTIFICATION_TYPE: 'Type',
  TABLE_NOTIFICATION_LAST_DATE_UPDATE: 'Last Update Date',
};

export default locale;
